import graphql__5dae905d103fdb88f8fb from "./__generated__/CityWalkCompleteDialog_cityWalk.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";

import MapPanelsManager from "../Maps/MapPanel/MapPanelsManager";
import MapPanel from "../Maps/MapPanel/MapPanel";
import MapPanelActions from "../Maps/MapPanel/MapPanelActions";
import Button from "../Buttons/Button";
import { useFormatMessageWithCustomization } from "../Intl/Context";
import { useMapContext } from "../Maps/MapContext";

import { completeCityWalkContribution } from "../../mutations/CompleteCityWalkContributionMutation";
import { setCityWalkCompleteDialogActive } from "../../reducers/cityWalks";

const CityWalkCompleteDialog = props => {
  const cityWalk = useFragment(CityWalkCompleteDialog_cityWalk, props.cityWalk);
  const { activeContribution } = cityWalk;

  const { mapKey } = useMapContext();
  const dispatch = useDispatch();

  const setDialogHidden = useCallback(() => {
    dispatch(setCityWalkCompleteDialogActive(mapKey, false));
  }, [dispatch, mapKey]);

  const handleFinalizeCityWalkButtonClicked = useCallback(() => {
    completeCityWalkContribution(activeContribution, setDialogHidden);
  }, [activeContribution, setDialogHidden]);

  const translateWithCustomization = useFormatMessageWithCustomization(
    cityWalk.customIntlMessages
  );
  const cityWalkPartiallyCompleted = translateWithCustomization(
    intlMessages.cityWalkPartiallyCompleted
  );
  const finalizeCityWalk = translateWithCustomization(intlMessages.finalizeCityWalk);
  const resume = translateWithCustomization(intlMessages.resume);

  return (
    <MapPanelsManager>
      <MapPanel
        className="map-city-walk-complete-dialog"
        isToggleable={false}
        isOpen={true}
      >
        <p
          className="box padding-md"
          dangerouslySetInnerHTML={{ __html: cityWalkPartiallyCompleted }}
        />
        <MapPanelActions>
          <Button
            type="button"
            className="btn btn-block-md btn-primary"
            onClick={handleFinalizeCityWalkButtonClicked}
            label={finalizeCityWalk}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />

          <Button
            type="button"
            className="btn btn-block-md"
            onClick={setDialogHidden}
            label={resume}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />
        </MapPanelActions>
      </MapPanel>
    </MapPanelsManager>
  );
};

const CityWalkCompleteDialog_cityWalk = graphql__5dae905d103fdb88f8fb;

export default CityWalkCompleteDialog;

const intlMessages = defineMessages({
  cityWalkPartiallyCompleted: {
    id: "city_walk.completeDialog.cityWalkPartiallyCompleted",
    defaultMessage: `
      Vous n'avez pas renseigné toutes les étapes de la balade, que
      souhaitez-vous faire ?
    `
  },
  finalizeCityWalk: {
    id: "city_walk.completeDialog.finalizeCityWalk",
    defaultMessage: "Terminer la balade",
    description: `
      Libellé du bouton pour confirmer que le participant souhaite terminer la balade même 
      s'il reste des étapes à renseigner
    `
  },
  resume: {
    id: "city_walk.completeDialog.resume",
    defaultMessage: "Répondre aux étapes encore vides",
    description: `
      Libellé du bouton pour retourner à la balade s'il reste des étapes à renseigner
    `
  }
});
